import React from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import { Link } from 'react-router-dom';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import CardContainer from 'components/kea/CardContainer';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { generateAndDownloadCSV } from '../components/analyticsCsv';
import AnalyticsMetricBar from '../components/AnalyticsMetricBar';

const MainSection = ({ match, queryPopular }) => {
  const localizeMessage = useLocalizedMessage();
  const { isFetching, data, error } = queryPopular;
  const rows = Array.isArray(data) ? data : [];
  const maximumSearches = Math.max(1, ...rows.map((row) => Number(row.total || 0)));

  const headCells = [
    {
      id: 'query', numeric: false, label: localizeMessage('analytics.table.query'), sortKey: 'queryText',
    },
    { id: 'users', numeric: true, label: localizeMessage('analytics.table.users') },
    {
      id: 'total',
      numeric: true,
      label: localizeMessage('analytics.table.total'),
      render: (value) => (
        <AnalyticsMetricBar
          value={value}
          maximum={maximumSearches}
          label={localizeMessage('analytics.table.total')}
          tone="searches"
        />
      ),
    },
    { id: 'click', numeric: true, label: localizeMessage('analytics.table.click') },
    { id: 'noaction', numeric: true, label: localizeMessage('analytics.table.noAction') },
    { id: 'refine', numeric: true, label: localizeMessage('analytics.table.refine') },
    {
      id: 'ctr',
      numeric: true,
      label: localizeMessage('analytics.table.ctr'),
      exportValue: (row) => Math.round(Number(row.ctr || 0) * 100),
      render: (value) => (
        <AnalyticsMetricBar
          value={value}
          maximum={100}
          valueFormatter={(metric) => `${metric.toFixed(1)}%`}
          label={localizeMessage('analytics.table.ctr')}
          tone="clickRate"
        />
      ),
    },
  ];

  const prepareRows = (rows) => rows.map((el, index) => ({
    ...el,
    queryText: el.query,
    ctr: Number((Number(el.ctr || 0) * 100).toFixed(1)),
    query: (<Link to={`${match.url}/query/${el.query}`}>{el.query}</Link>),
    id: `${el.query}-${index}`,
  }));

  return (
    <CardContainer
      headerId="search.analytics.queryPopular.header"
      styleName="noMargin"
      tableSurface
      isFetching={isFetching}
      error={error}
      actionComponent={(
        <Grid item xs={12} sm={6} md={6} lg={12}>
          <Button startIcon={<CloudDownloadIcon />} onClick={() => generateAndDownloadCSV(headCells, data)}>{localizeMessage('analytics.downloadCsv')}</Button>
        </Grid>
      )}
    >
      <AnalyticTable
        rows={prepareRows(rows)}
        headCells={headCells}
        orderById="total"
      />
    </CardContainer>
  );
};

MainSection.defaultProps = {
  queryPopular: {

  },
};

MainSection.propTypes = {
  match: PropTypes.any.isRequired,
  queryPopular: PropTypes.shape({
    isFetched: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    data: PropTypes.array,
  }),
};

export default MainSection;
